<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayoutAlign.gt-md="space-between center">
    <div class="title">
      <span>Concursos</span>    
    </div>
  </div>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>

      <ng-container matColumnDef="campus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Unidade</th>
        <td mat-cell *matCellDef="let row" [matTooltip]="row.campus">{{ row.siglaUnidade }}</td>
      </ng-container>

      <ng-container matColumnDef="processo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Processo</th>
        <td mat-cell *matCellDef="let row">{{ row.processo }}</td>
      </ng-container>

      <ng-container matColumnDef="titulo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Título</th>
        <td mat-cell *matCellDef="let row">{{ row.titulo }}</td>
      </ng-container>

      <ng-container matColumnDef="inscricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Inscrição</th>
        <td mat-cell *matCellDef="let row">
          {{ row.inicio | date : 'dd/MM/yyyy' }} a {{ row.fim | date : 'dd/MM/yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
        <td mat-cell *matCellDef="let row">{{ getTipo(row.tipo) }}</td>
      </ng-container>

      <ng-container matColumnDef="andamento">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Etapa</th>
        <td mat-cell *matCellDef="let row">
          {{ row.andamento }}<br />{{ row.andamentoData | date : 'dd/MM/yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action" *ngIf="canOpenOptions()">
        <th mat-header-cell *matHeaderCellDef>Provas</th>
        <td mat-cell *matCellDef="let row">
          <button
            color="basic"
            [routerLink]="['/comissao-julgadora/listar-provas', row.id]"
            title= "{{ row.quantidadeInscritos }} Inscrições">
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>
      
      <ng-container matColumnDef="classificacao">
        <th mat-header-cell *matHeaderCellDef class="text-center">Classificação</th>
        <td mat-cell *matCellDef="let row" class="text-center">
          <button
            *ngIf="row.papelExaminador === 'PRESIDENTE'"
            color="basic"
            title="Classificação final."
            [routerLink]="['/comissao-julgadora/resultado/classificacao', row.id]">
            <mat-icon>leaderboard</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="9">Nenhum registro disponível</td>
      </tr>
    </table>

    <app-default-paginator #paginator [length]="totalElements" [pageSize]="20"></app-default-paginator>
  </div>
</div>
